// extracted by mini-css-extract-plugin
export default {"Box":"header-grid-cell-layout-module__Box__g1CmKXx"};